/**
 * API endpoint configuration for different environments
 */
export const endpoints = {
    development: {
        clientApi: 'http://localhost:3000/api/v1',
        adminApi: 'http://localhost:3000/admin/v1',
    },
    staging: {
        clientApi: 'https://api-assist.harness-dev.com/api/v1',
        adminApi: 'https://api-assist.harness-dev.com/admin/v1',
    },
    production: {
        clientApi: 'https://api-assist.harness.co/api/v1',
        adminApi: 'https://api-assist.harness.co/admin/v1',
    },
};
/**
 * Get the current environment from NODE_ENV or default to development
 */
export function getCurrentEnvironment() {
    // Check if we're in a Node.js environment
    if (typeof process !== 'undefined' && process.env?.NODE_ENV) {
        return process.env.NODE_ENV;
    }
    return 'development';
}
/**
 * Get API endpoints for the current environment
 */
export function getApiEndpoints(environment) {
    // Check for regular environment variable (for Node.js environments)
    if (typeof process !== 'undefined' && process.env?.API_BASE_URL) {
        const baseUrl = process.env.API_BASE_URL;
        return {
            clientApi: baseUrl,
            adminApi: process.env.API_ADMIN_BASE_URL || `${baseUrl.replace('/api/v1', '')}/admin/v1`,
        };
    }
    // For Vite environments, the environment variable will be replaced at build time
    // @ts-ignore - Vite will replace this at build time
    if (typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_BASE_URL) {
        // @ts-ignore
        const baseUrl = import.meta.env.VITE_API_BASE_URL;
        // @ts-ignore
        const adminUrl = import.meta.env.VITE_API_ADMIN_BASE_URL || `${baseUrl.replace('/api/v1', '')}/admin/v1`;
        return {
            clientApi: baseUrl,
            adminApi: adminUrl,
        };
    }
    // Fall back to hardcoded endpoints
    const env = environment || getCurrentEnvironment();
    const envEndpoints = endpoints[env];
    if (envEndpoints) {
        return envEndpoints;
    }
    return endpoints.development;
}
/**
 * Get the client API base URL for the current environment
 */
export function getClientApiBaseUrl(environment) {
    return getApiEndpoints(environment).clientApi;
}
